<template>
  <div ref="appContent" class="app-content">
    <el-card>
      <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
      >
        <el-form-item label="合同编号：">
          <el-input
              v-model="dataForm.agreementCode"
              placeholder=""
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="出入库：">
          <el-select v-model="dataForm.storeType">
            <el-option value="" label="请选择"></el-option>
            <el-option :value="1" label="入库"></el-option>
            <el-option :value="-1" label="出库"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库存品类：">
          <el-select v-model="dataForm.productType">
            <el-option value="" label="请选择"></el-option>
            <el-option value="原料" label="原材料"></el-option>
            <el-option value="产品" label="成品"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库：">
          <storages v-model="dataForm.storageId"></storages>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="doExport()">导出</el-button>
        </el-form-item>
      </el-form>
      <el-table
          v-loading="dataListLoading"
          :data="dataList"
          border
          style="width: 100%"
          @selection-change="dataListSelectionChangeHandle"
          :max-height="maxTableHeight"
      >
        <el-table-column
            label="行号"
            type="index"
            header-align="center"
            align="center"
            width="50"
        ></el-table-column>
        <el-table-column label="图片" header-align="center" align="center" width="140">
          <template v-slot:default="scope">
            <el-image style="width: 100px;height:100px;" :preview-src-list="scope.row.imgs" v-if="scope.row.previewImg"
                      :src="scope.row.previewImg" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="产品/原料" header-align="center" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.productCode">
              品番号：{{ scope.row.productCode }}
            </div>
            <div>品名：{{ scope.row.productName }}</div>
            <div class="flex">
              <div style="" v-if="scope.row.color">
                颜色：{{ scope.row.color }}
              </div>
              <div style="margin-left:20px;" v-if="scope.row.size">
                规格：{{ scope.row.size }}
              </div>
            </div>
            <div class="flex">
              <div v-if="scope.row.attr1">幅宽：{{ scope.row.attr1 }}</div>
              <div v-if="scope.row.attr2" style="margin-left:20px;">
                克重：{{ scope.row.attr2 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="出入库类型"
            header-align="center"
            align="center"
            width="100"
        >
          <template slot-scope="scope">
            <div style="color:#67C23A;" v-if="scope.row.type === 1">
              入库
            </div>
            <div style="color:#F56C6C;" v-else-if="scope.row.type === -1">
              出库
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="数量"
            header-align="center"
            align="center"
            width="100"
        >
          <template slot-scope="scope">
            <div style="color:#67C23A;" v-if="scope.row.type === 1">
              {{ scope.row.count }}
            </div>
            <div style="color:#F56C6C;" v-else-if="scope.row.type === -1">
              {{ scope.row.count }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="storageName"
            label="仓库"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="operateTime"
            label="出入库日期"
            header-align="center"
            align="center"
            :formatter="timeFormatter"
            width="110"
        >
        </el-table-column>
        <el-table-column
            prop="reason"
            label="原因"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.reason || scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column
            prop="creatorName"
            label="制单人"
            header-align="center"
            width="120"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="createDate"
            label="制单时间"
            header-align="center"
            align="center"
            width="160"
        >
        </el-table-column>
<!--        <el-table-column label="状态" header-align="center" align="center" width="80">-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag :type="scope.row.status === 10 ? 'primary' : 'danger'">{{-->
<!--                $dictFormat('purchase_log_status', scope.row.status)-->
<!--              }}-->
<!--            </el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
            :label="$t('handle')"
            fixed="right"
            header-align="center"
            align="center"
            width="130"
        >
          <template slot-scope="scope">
            <el-button
                v-if="$hasPermission('trade:factorystorelog:update')"
                type="text"
                size="small"
                @click="showUpdateDialog(scope.row)"
            >修改
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </el-card>
    <UpdateDialog ref="updateDialog"></UpdateDialog>
  </div>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixins/view-module'
import UpdateDialog from './update'
export default {
  mixins: [mixinViewModule],
  components: { UpdateDialog },
  props:{
    type:{
      type:Number,
      default:1
    },
    productyType:{
      type:String,
      default:'原料'
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/factorystorelog/page',
        exportURL: '/trade/factorystorelog/export',
        getDataListIsPage: true,
        activatedIsNeed: false,
      },
      dataForm: {
        storageId: '',
        agreementCode: '',
        productType: '',
        storeType: '',
        ids: [],
      },
      storeTypeName: {
        '1': '入库',
        '-1': '出库',
      },
      currentId: '',
      maxTableHeight: 100,
    }
  },
  computed: {
    optName () {
      return this.storeTypeName[String(this.storeType)]
    },
  },
  watch: {
    type:{
      handler:function(newVal){
        this.dataForm.storeType=newVal
        this.reload()
      },
      immediate:true
    },
    productyType:{
      handler:function(newVal){
        this.dataForm.productyType=newVal
        this.reload()
      },
      immediate:true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.maxTableHeight =
          this.$refs.appContent.clientHeight -
          this.$refs.queryForm.$el.clientHeight -
          60
    })
  },
  activated () {

  },
  methods: {
    //显示修改
    showUpdateDialog (row) {
      this.$refs.updateDialog.storeType = row.type
      this.$refs.updateDialog.id = row.id
      this.$refs.updateDialog.init()
    },
    timeFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return "";
      }
      return moment(cellValue).format("yyyy-MM-DD");
    },
  },
}
</script>
